/** @jsx jsx */
import React, { useCallback, useContext, useState } from 'react'
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import {
  getUnitGroup,
  postUnitGroup,
  deleteUnitGroup,
  getUnitGroupScreen,
} from 'api/pgads'
import { setUnitGroups } from 'core/actions'
import { connect } from 'react-redux'
import R from 'ramda'
// import ErrorModal from 'core/component/ErrorModal'
// import UnitGroupEntry from './UnitGroupEntry'
// import EditPrompt from './EditPrompt'
// import { Overlay, DatePicker } from 'core'

import {
  getUtilityNameMap,
  getUnits,
  getUnitNameMap,
  getApiTargetInfo,
  getUnitTypeCode,
  getUnitGroups,
} from 'core/selectors'

import GenericEditScreen, {
  RowButtons,
  RowContainer,
} from 'core/component/GenericEditScreen'
import moment from 'moment'
import { DatePicker } from 'antd'
import { Filler } from '../../../core/screen-util'
import UnitGroupModal from './UnitGroupModal'
import { ErrorContext } from 'context'
import { strCol, dateCol } from '@integec/grid-tools/lib/cols'
const GroupLabel = styled.div`
  font-weight: bold;
  font-size: 1.4em;
`
const CountLabel = styled.div`
  font-size: 1.2em;
  color: #777;
  margin-left: 1em;
`
const DateLabel = styled.div`
  font-size: 1em;
  color: #777;
  margin-left: 1em;
`

const UnitGroup = props => {
  const [selectedDate, setSelectedDate] = useState(moment())
  const { setError } = useContext(ErrorContext)

  const renderModal = ({ hideModal, modalInfo, list, ...rest }) => (
    <UnitGroupModal
      hide={hideModal}
      data={modalInfo}
      availableUnits={props.availableUnits}
      unitNameMap={props.unitNameMap}
      utilityNameMap={props.utilityNameMap}
      list={list}
      {...props}
      {...rest}
    />
  )
  const renderRow = ({ item, popModal, style, onDelete }) => (
    <RowContainer style={style}>
      <GroupLabel>{item.unitGroup}</GroupLabel>
      <CountLabel>{item.units.length} units</CountLabel>
      <DateLabel>
        <b>Effective Date :</b>{' '}
        {moment(item.effectiveDate).format('MM/DD/YYYY')}
      </DateLabel>
      <Filler />
      <RowButtons
        item={{
          ...item,
          effectiveDate: moment(item.effectiveDate).format('YYYY-MM-DD'),
        }}
        onDelete={onDelete}
        popModal={popModal}
        duplicateClicked={() =>
          popModal({
            ...item,
            isNew: true,
            isDuplicate: true,
            effectiveDate: moment(),
          })
        }
      />
    </RowContainer>
  )

  const afterSaveCall = _ => {
    getUnitGroup(props.targetInfo)(selectedDate).fork(setError, data =>
      props.saveUnitGroup(data)
    )
  }

  const exportFunc = data => {
    const exData = (data || []).map(u =>
      (u.units || []).map(un => ({
        unitGroup: u.unitGroup,
        effectiveDate: u.effectiveDate,
        utility: un.substr(0, 3),
        utilityName: props.utilityNameMap[un.substr(0, 3)] || un.substr(0, 3),
        unit: un,
        unitName: props.unitNameMap[un] || un,
      }))
    )
    const flatData = R.flatten(exData)
    return R.sortWith([
      R.ascend(R.compose(R.toLower, R.prop('unitGroup'))),
      R.ascend(R.compose(R.toLower, R.prop('unitName'))),
      R.ascend(R.compose(R.toLower, R.prop('utilityName'))),
    ])(flatData)
  }

  const ExportHeader = [
    strCol({
      ident: 'unitGroup',
      display: 'Unit Group Name',
      width: 200,
    }),
    dateCol({
      ident: 'effectiveDate',
      display: 'Effective Date',
    }),
    strCol({
      ident: 'utilityName',
      display: 'Utility',
      width: 450,
      isRequired: true,
      sortOrder: 'asc',
      // dataFormatter: ({ value }) => props.utilityNameMap[value] || value,
    }),
    strCol({
      ident: 'unitName',
      display: 'Unit',
      width: 450,
      isKey: true,
      sortOrder: 'asc',
      // dataFormatter: ({ value }) => props.unitNameMap[value] || value,
    }),
  ]
  const getLoadCriteria = useCallback(
    () => ({
      moment: selectedDate,
      isAll: true,
      orig: false,
    }),
    [selectedDate]
  )

  return (
    <GenericEditScreen
      // sortOnData={sortOnData}
      isExportAvaliable
      exportHeaders={ExportHeader}
      exportFunc={exportFunc}
      sort={data =>
        data.sort((d1, d2) =>
          d1 === undefined || d2 === undefined
            ? 1
            : d1.unitGroup.toLowerCase() <= d2.unitGroup.toLowerCase()
            ? -1
            : 1
        )
      }
      afterSaveCall={afterSaveCall}
      title="Unit Groups"
      loadApiTask={getUnitGroupScreen}
      createApiTask={postUnitGroup}
      updateApiTask={postUnitGroup}
      deleteApiTask={deleteUnitGroup}
      renderModal={renderModal}
      renderRow={renderRow}
      rowHeight={50}
      listHeightOffset={360}
      acceptFilter={item => filterText =>
        filterText == null ||
        (item.unitGroup || '').toLowerCase().includes(filterText.toLowerCase())}
      criteria={() => (
        <div style={{ marginLeft: '30px' }}>
          <label>Effective Date : </label>
          <DatePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={selectedDate}
            onChange={setSelectedDate}
          />
        </div>
      )}
      getLoadCriteria={getLoadCriteria}
      dataMatcher={d1 => d2 =>
        d1.unitGroup === d2.unitGroup && d1.effectiveDate === d2.effectiveDate}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  availableUnits: getUnits(state),
  unitNameMap: getUnitNameMap(state),
  utilityNameMap: getUtilityNameMap(state),
  unitTypeCode: getUnitTypeCode(state),
  unitGroups: getUnitGroups(state),
})

const mapDispatchToProps = dispatch => ({
  saveUnitGroup: data => dispatch(setUnitGroups(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UnitGroup)
